import { PlaceholderPage } from '../../components/ui/PlaceholderPage.tsx'
import { IconUser } from '@tabler/icons-react'
export function ProfilePage() {
  return <PlaceholderPage title="My Profile" description="View and edit your profile information" icon={<IconUser size={22} className="text-zinc-600" />} />
}
